// Cookie that mirrors the client-resolved value of the
// `mainnet_enabled` Statsig gate so server-side middleware can branch
// on it. Without this mirror, middleware can only read the gate's
// hard-coded registry default — DevToolkit overrides and live Statsig
// values are client-only and never reach the edge.
//
// Resolution order on the server (middleware):
//   1. Cookie value (`'true'` / `'false'`) — set by the client after
//      Statsig + DevToolkit overrides have applied.
//   2. Registry default — used when the cookie is absent (first visit
//      before client mirror runs).
//
// Cookie is short-ish (1 day) so a stale value doesn't outlive a
// session. Refreshed on every navigation while the client is loaded.

export const MAINNET_GATE_COOKIE: string = 'MAINNET_ENABLED_GATE';
export const MAINNET_GATE_COOKIE_MAX_AGE: number = 24 * 60 * 60; // 1 day

export function parseMainnetGateCookie(raw: string | undefined | null): boolean | null {
  if (raw === 'true') return true;
  if (raw === 'false') return false;
  return null;
}
